import { useMemo } from 'react';

import { EndpointGroup } from 'modules/endpoints/types';
import { getSubChainFromGroup } from 'domains/chains/utils/getSubChainFromGroup';

export const chackHasWSFeature = (group: EndpointGroup) => {
  const subChain = getSubChainFromGroup(group);

  return subChain?.hasWSFeature;
};

export const useWsFeatureEndpoints = (group: EndpointGroup) => {
  const { urls } = group;

  const wss = useMemo(() => urls.flatMap(({ ws }) => (ws ? [ws] : [])), [urls]);

  return { wss };
};
